import CategoryPage from ".";

const CategoryMasterPage = () => (
  <CategoryPage
    type="all"
    title="Data Kategori"
    subtitle="master kategori"
    description="Master bentuk produk/material dengan flag pembeda Produk atau Material"
  />
);

export default CategoryMasterPage;
